/* eslint-disable compat/compat */
import axios from 'axios';

export const getCsrfToken = (): string | null => {
  const element = document.getElementsByName('__RequestVerificationToken')[0] as HTMLInputElement;
  if (element != null) {
    return element.value;
  }
  return null;
};

export const getHeaders = (): Headers => {
  const headers = new Headers();
  const token = getCsrfToken();
  headers.append('Content-Type', 'application/json');
  if (token != null) {
    headers.append('RequestVerificationToken', token);
  }
  return headers;
};

export const apiService = {
  submitForm: (data: any) => axios.post('/digital/PaymentDetails/submit', data),
};
